import useChatList from '../../../Hooks/useChatList';
import ChatListItem from '../ChatListItem/ChatListItem';
import AssistentList from '../components/AssistentList';
import Input from '../../Utility/FormElements/Input';
import { ChatList as ChatListType } from '../../../Types';
import { useMemo } from 'react';

function ChatListMobile() {
    const {
        ChatListActions,
        i18n,
        groupedChats,
        setListItemEdit,
        currentURL,
        ListItemEdit,
        chatsFetched,
        filterValue,
        setFilter,
        allChatsLoaded,
    } = useChatList();

    const chatListItems = useMemo(() => {
        if (!groupedChats || Object.entries(groupedChats).length === 0) return null;

        return Object.entries(groupedChats).map(([headline, chatlistItems], groupIndex) => (
            <div className="gap-1 flex flex-col mb-4" key={groupIndex}>
                <p className="font-normal text-chatlist-timeSeparatorColor py-0 py-2 pl-1 m-0 sticky top-0 bg-chatlist-background z-10">
                    {headline}
                </p>
                {chatlistItems?.map((chatlistItem: ChatListType, itemIndex: number) => (
                    <div key={itemIndex}>
                        <ChatListItem
                            setCanEdit={setListItemEdit}
                            editItem={ListItemEdit}
                            chatIdentifier={chatlistItem.identifier}
                            currentUrl={currentURL}
                            deleteChat={ChatListActions.deleteChatHandler}
                            chatTitle={chatlistItem.title || 'n/a'}
                            updateChatTitle={ChatListActions.updateTitle}
                            assistantTitle={chatlistItem?.assistantTitle}
                            assistantImage={chatlistItem?.assistantImage}
                        />
                    </div>
                ))}
            </div>
        ));
    }, [groupedChats, ListItemEdit, setListItemEdit, currentURL, ChatListActions]);

    const AssistentListMemo = useMemo(() => <AssistentList />, []);

    return (
        <div className="relative h-full flex flex-col">
            <div className="pt-4 px-0">
                <div className="relative w-full">
                    <div className="flex w-full justify-between items-center">
                        <h5 className="font-normal text-layout-textcolor m-0 py-0 pl-1">
                            {i18n.translate({ id: 'chatlist.assistants', sourceName: 'Main' })}
                        </h5>
                    </div>

                    <div className="overflow-hidden transition-all duration-300 pt-4">{AssistentListMemo}</div>
                </div>

                <hr className="border-t border-layout-borderColor w-full my-5"></hr>

                <Input
                    value={filterValue}
                    onChange={(value) => setFilter(value)}
                    placeholder={i18n.translate({ id: 'filter.placeholder', sourceName: 'Main' })}
                    className="w-full"
                />
                <hr className="border-t border-layout-borderColor w-full my-5"></hr>

                <h5 className="font-normal text-layout-textcolor m-0 py-0 pl-1 mb-4">
                    {i18n.translate({ id: 'chatlist.toggleText', sourceName: 'Main' })}
                </h5>
            </div>
            <div className="flex">
                <div className="min-h-0 overflow-y-auto px-0 ">
                    {allChatsLoaded.length !== 0 ? (
                        chatListItems ?? (
                            <p>
                                {i18n.translate({
                                    id: 'filter.notFound',
                                    sourceName: 'ChatList',
                                })}
                            </p>
                        )
                    ) : !chatsFetched ? (
                        <div className="flex items-center justify-center w-full">
                            <div className="relative flex items-center justify-center h-10 w-10">
                                <div className="absolute inline-block w-10 h-10 border-4 border-t-primary border-gray-300 rounded-full animate-spin"></div>
                            </div>
                        </div>
                    ) : (
                        <p className="text-center">
                            {i18n.translate({
                                id: 'filter.notFound',
                                sourceName: 'ChatList',
                            })}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ChatListMobile;
